import {
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Skeleton,
} from "@mui/material";
import { Redirect } from "react-router-dom";
import { useDocumentTitle } from "../hooks";
import { ContinueWatchingHub, LibraryHub, RecentPeopleHub } from "../components/Hubs";
import { Footer, MuiNavLink } from "../components/_Misc";
import { useAuthContext } from "@src/AuthContext";
import { links } from "@src/constants";
import { Box } from "@mui/system";
import { Tv } from "@mui/icons-material";
import trpcClient from "@services/rpc-client";
import { useQuery } from "react-query";
import { useState } from "react";

export function HomePage() {
  const authInfo = useAuthContext();
  const isAuthedMember = authInfo.authed && authInfo.is_member;
  useDocumentTitle();

  const email = (
    <Link href="mailto:liara.evie@gmail.com" color="text.primary" underline="always">
      e-mail
    </Link>
  );

  const [open, setOpen] = useState(false);

  return isAuthedMember ? (
    <>
      <Container
        maxWidth={"lg"}
        sx={(t) => ({
          display: "flex",
          paddingTop: 1.5,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 22,
          [t.breakpoints.down("sm")]: { fontSize: 17, flexDirection: "column-reverse", alignItems: "center" },
        })}
      >
        {/* Link sharing warning */}
        <Box
          sx={(t) => ({
            pt: 1.5,
            pr: 4,
            [t.breakpoints.down("sm")]: { paddingRight: 0 },
          })}
        >
          <Box textAlign={"center"}>Hi {authInfo.name || authInfo.email?.split("@")?.[0]}!</Box>
          <Box sx={{ pl: 0, mt: "22px", mb: "22px" }}>
            <div>In case you missed it, we've moved to a new forum 🎉</div>
            <div>It has been a great improvement from our Google Group so far!</div>

            <div>
              Looking for your invite link? <Button onClick={() => setOpen(true)}>Click here!</Button>
            </div>

            {open && <InviteLinkModal onClose={() => setOpen(false)} />}

            {/* <div>Please remember to not share our links outside the group.</div>
            <Box sx={(t) => ({ [t.breakpoints.down("sm")]: { marginTop: "16px" } })}>
              If you encounter any issues, have questions or suggestions for the site, please contact me via {email}
            </Box> */}
          </Box>

          <Box textAlign={"center"}>
            <MuiNavLink
              fontSize={"18px"}
              // to={generatePath(links.folder, { folder: "shorts" })}
              to={links.folders} // we put this back so people see the "surprise me" button
              position={"relative"}
              underline="hover"
              fontWeight={"bold"}
              // color={(t) => t.palette.primary.main as unknown as string}
              color={"primary.dark"}
            >
              Browse Libraries
              <Tv sx={{ marginLeft: 0.5, position: "absolute", top: -2 }} />
            </MuiNavLink>
          </Box>
        </Box>

        {/* Logo */}
        <div>
          <Box
            component="img"
            src="/logo.png"
            alt={"logo"}
            sx={{
              width: "40vw",
              // height: "40vw",
              maxWidth: "300px",
              maxHeight: "250px",
            }}
          />
        </div>
      </Container>

      {/* Hubs */}
      <Container style={{ marginTop: 20 }}>
        <ContinueWatchingHub /> {/* has the refetch indicator */}
        <RecentPeopleHub />
        <LibraryHub />
      </Container>

      <Footer style={{ marginTop: 0 }} />
    </>
  ) : authInfo && !authInfo.authed ? (
    <Redirect to={{ pathname: "/login" }} />
  ) : authInfo ? (
    <Box textAlign="center">
      <span>
        You're currently signed in as {authInfo.email}
        <br />
        However our system detects that you are not a member of the group.
        <br />
        If you are a member and you're signed in with the correct account, try refreshing the page in a few minutes.
      </span>
    </Box>
  ) : (
    // <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <CircularProgress color="secondary" />
    </div>
  );
}

function InviteLinkModal(o: { onClose: () => void }) {
  const { data } = useQuery("me/forum-invite-link", {
    queryFn: () => trpcClient.query("me/forum-invite-link"),
  });

  return (
    <Dialog open={true} onClose={o.onClose} fullWidth>
      <DialogTitle> Forum Invite Link</DialogTitle>

      <DialogContent dividers>
        {data ? (
          <>
            <DialogContentText>{data.message}</DialogContentText>
            <Link href={data.link} target="_blank" underline="always">
              {data.link}
            </Link>
          </>
        ) : (
          <Skeleton component={"div"} height={40} />
        )}
      </DialogContent>
    </Dialog>
  );
}
